import { CmpsCardRowMenuData, CmpsCardRowSubMenuItem } from '@cmps/ng-kit';
import { TranslateService } from '@ngx-translate/core';

import { epicDependencies } from '../../store';
import { CoachingMyOaScoreTypeTranslationMap } from '../constants/coaching-my-oa-score-type-translation-map';
import { MyCoachingCardGroup } from '../models/my-coaching-card-group.model';
import { OaScoreType } from '../models/oa-score-type.enum';
import { TranslationKeyMap } from '../my-coaching-card.i18n';

export function getMenuData(
    oaSummaryItems: MyCoachingCardGroup[],
): CmpsCardRowMenuData {
    const subMenu: CmpsCardRowSubMenuItem[] = [];
    const translateService =
        epicDependencies.injector.get<TranslateService>(TranslateService);

    oaSummaryItems.forEach((e) => {
        if (e.type !== OaScoreType.OA) {
            subMenu.push({
                value: translateService.instant(
                    CoachingMyOaScoreTypeTranslationMap[e.type],
                ),
                selected:
                    e.type === OaScoreType.OA ||
                    e.type === OaScoreType.Super_Group_OA ||
                    e.type === OaScoreType.Site_OA,
                id: e.type,
            });
        }
    });

    return {
        dropdownMenuValues: [
            {
                value: translateService.instant(
                    TranslationKeyMap._9917_LAUNCH_OA,
                ),
                id: OaScoreType.Launch_OA,
                selected: false,
            },
            {
                value: translateService.instant(
                    TranslationKeyMap._9918_PEER_COMPARE,
                ),
                id: OaScoreType.Peer_Compare,
                selected: false,
                subMenu,
            },
        ],
    };
}
